import { render, staticRenderFns } from "./searchbox.vue?vue&type=template&id=674e888c&scoped=true&lang=pug&"
import script from "./searchbox.vue?vue&type=script&lang=js&"
export * from "./searchbox.vue?vue&type=script&lang=js&"
import style0 from "./searchbox.vue?vue&type=style&index=0&id=674e888c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e888c",
  null
  
)

export default component.exports